import { useMemo } from 'react';
import { createContext } from '../../../../../../hooks/createContext';

type GroupingContext = {
    grouping: string | null;
    setGrouping: React.Dispatch<React.SetStateAction<string | null>>;
};

const [useCtx, Provider] = createContext<GroupingContext>();

// eslint-disable-next-line react-refresh/only-export-components
export const useGroupingContext = useCtx;

export const GroupingContextProvider = ({ grouping, setGrouping, children }: GroupingContext & { children: React.ReactNode }) => {
    const context = useMemo(() => ({ grouping, setGrouping }), [grouping, setGrouping]);
    return <Provider value={context}>{children}</Provider>;
};
